var exports = {
  "x6": "HelpButton.module__button___YUdLbW",
  "td": "HelpButton.module__iconText___YUdLbW",
  "ro": "HelpButton.module__menuIcon___YUdLbW",
};

module.exports = exports;
